import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import { GMapsMultipleMarkerComponent } from '@/components/reusable/GMapsComponent/GMapsMultipleMarkerComponent';
import { NewHeaderSearchComponent } from '@/components/general/NewSearchComponent';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useNavigate } from 'react-router-dom';
import { Navigation, Pagination } from 'swiper/modules';
import ReactPixel from 'react-facebook-pixel';
import Label from '@/components/form/Label/Label';
import HelmetComponent from '@/components/general/Helmet/HelmetComponent';
import NewSpaceCardBlueVersion from '@/components/reusable/NewSpaceCardBlueVersion/NewSpaceCardBlueVersion';
import './WorkspaceMapView.scss';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const WorkspaceMapView = (props) => {
  const { workspacesDataFromBackend } = props;
  const [showVerticalListScreen, setShowVerticalListScreen] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const languageData = useSelector((state) => state.lenguage?.lang);
  const navigate = useNavigate();
  const esDescription = 'Esta es la lista de espacios disponibles en Popnest.';
  const enDescription = 'This is the list of available spaces on Popnest.';

  const goToSpaceDetails = (spaceData) => {
    ReactPixel.trackCustom('clickReservationButton', { clave: spaceData });
    navigate(
      languageData === 'ES'
        ? '/confirmar-reservacion2nd/' +
            spaceData?.relationship_title +
            '/' +
            spaceData?.id_relationship
        : '/confirm-reservation2nd/' +
            spaceData?.relationship_title +
            '/' +
            spaceData?.id_relationship,
      {
        state: { spaceData },
      },
    );
  };

  return (
    <FlexContainer className={'flex-column width100'}>
      <HelmetComponent
        title={languageData === 'EN' ? 'Spaces - Popnest' : 'Espacios - Popnest'}
        description={languageData === 'EN' ? enDescription : esDescription}
        graphTitle={languageData === 'EN' ? 'Spaces - Popnest' : 'Espacios - Popnest'}
        graphDescription={languageData === 'EN' ? enDescription : esDescription}
      />
      {!showVerticalListScreen && (
        <>
          <FlexContainer
            className="flex-column align-center justify-center width100"
            style={{
              overflow: 'hidden',
            }}
          >
            <NewHeaderSearchComponent />
            <GMapsMultipleMarkerComponent
              center={{
                space_latitude: '19.332608',
                space_logitude: '-99.2402091',
              }}
              lenguage={languageData}
              markers={workspacesDataFromBackend}
              customHeight={'700px'}
              onClick={() => console.log('Mapa de prueba')}
            />
          </FlexContainer>
          <FlexContainer
            className="flex-column align-center justify-center width100 pos-abs"
            style={{
              marginTop: '100%',
            }}
          >
            <Swiper
              className={'width100'}
              spaceBetween={20}
              slidesPerView={1.5}
              pagination={{ clickable: true }}
              modules={[Navigation]}
            >
              {Array.isArray(workspacesDataFromBackend) &&
                workspacesDataFromBackend.slice(0, 10).map((space, index) => (
                  <SwiperSlide key={index}>
                    <NewSpaceCardBlueVersion
                      key={index}
                      spaceInfo={space}
                      handleDetailButton={() => setShowVerticalListScreen(true)}
                      priceAndCapacityDetails
                      categoriesPills
                      //isBlueVersion
                      isLightBlueVersion
                    />
                  </SwiperSlide>
                ))}
            </Swiper>
          </FlexContainer>
        </>
      )}
      {showVerticalListScreen && (
        <FlexContainer className="flex-column align-center justify-center margt80 margb40 padlr10 gap-6">
          {Array.isArray(workspacesDataFromBackend) &&
            workspacesDataFromBackend
              .slice(0, 10)
              .map((space, index) => (
                <NewSpaceCardBlueVersion
                  key={index}
                  spaceInfo={space}
                  handleDetailButton={() => goToSpaceDetails(space)}
                  priceAndCapacityDetails
                  //isWhiteVersion
                  //isLightBlueVersion
                  //isBlueVersion
                  isPurple1Version
                  //isGreyVersion
                  //isPurple2Version
                />
              ))}
        </FlexContainer>
      )}
    </FlexContainer>
  );
};

export default WorkspaceMapView;
